import Navbar from "../../Navbar";
import { UrlApi } from "../../../services/apirest";
import { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  Paper,
  Grid,
  MenuItem,
} from "@mui/material";
import moment from "moment";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import NotAllow from "../notAllow/NotAllow";
import CambiarPrecioVianda from "../cambiarPrecioVianda/CambiarPrecioVianda";
import { Margin } from "@mui/icons-material";
import { logEventos } from "../../../services/services";

function Reporte() {
  const [mostrarInput, setMostrarInput] = useState(false);
  const [idSucursal, setIdSucursal] = useState(8);
  const [etiquetas, setEtiquetas] = useState([]);
  const [datosConsulta, setDatosconsulta] = useState({
    idSucursal: 8,
    fechainicio: "",
  });

  const handleChangeSucursal = (e) => {
    setIdSucursal(e.target.value);
  };

  const rrhh = localStorage.getItem("adminrrhh");

  const mostrarCambioDePrecio = () => {
    setMostrarInput(!mostrarInput);
  };

  const textoBotonCambiarPrecioInput = mostrarInput
    ? "Ocultar cambio de precio"
    : "Cambiar valor de las viandas";
  function almacenar(e) {
    setDatosconsulta({
      ...datosConsulta,
      [e.target.name]: e.target.value,
    });
  }

  const imprimirTXT = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${UrlApi}/viandas/pedidos/reportesMensualesTxt?fechaActual=${datosConsulta.fechainicio}&idSucursal=${idSucursal}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        alert("Algo anda mal al generar el TXT");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      moment.locale("es");
      const mesActual = moment(datosConsulta.fechainicio).format("MMMM"); // por ejemplo: "mayo"
      const nombreEmpresa = idSucursal === 8 ? "CasaCentral" : "Netizar";
      const nombreArchivo = `Reporte_mensual_viandas_${mesActual}_${nombreEmpresa}.txt`;

      const a = document.createElement("a");
      a.href = url;
      a.download = nombreArchivo;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error al descargar TXT:", err);
      alert("Ocurrió un error al descargar el archivo.");
    }
  };

  useEffect(() => {
  logEventos(
    "acceso al menú Reporte De Viandas", 
  "Viandas", 
  "Reporte De Viandas",
   localStorage.getItem("user"));
}, []);

  return rrhh === "1" ? (
    <>
      <Navbar />

      <Box
        sx={{
          maxWidth: 500,
          mx: "auto",
          mt: 8,
          p: 4,
          bgcolor: "#f5f5f5",
          borderRadius: 3,
          boxShadow: 4,
          textAlign: "center",
        }}
        component={Paper}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#1565c0" }}
        >
          Reporte Mensual de Viandas
        </Typography>

        <Typography variant="body2" gutterBottom sx={{ color: "#555" }}>
          Seleccioná un mes para generar el archivo de viandas en formato TXT.
        </Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <TextField
              select
              sx={{ mb: 2 }}
              label="Empresa"
              value={idSucursal}
              onChange={handleChangeSucursal}
              fullWidth
              InputProps={{
                sx: { textAlign: "left" },
              }}
              SelectProps={{
                sx: { textAlign: "left" },
              }}
            >
              <MenuItem value={8}>Casa Central</MenuItem>
              <MenuItem value={1000}>Netizar S.A.</MenuItem>
            </TextField>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                views={["month"]}
                label="Mes"
                value={
                  datosConsulta.fechainicio
                    ? moment(datosConsulta.fechainicio)
                    : null
                }
                onChange={(newValue) => {
                  if (newValue) {
                    setDatosconsulta((prev) => ({
                      ...prev,
                      fechainicio: moment(newValue).format("YYYY-MM-DD"),
                    }));
                  }
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "medium",
                    InputLabelProps: { shrink: true },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              size="large"
              onClick={imprimirTXT}
              disabled={!datosConsulta.fechainicio}
              sx={{
                bgcolor: "#1976d2",
                color: "#fff",
                "&:hover": {
                  bgcolor: "#1565c0",
                },
                fontWeight: "bold",
                py: 1.5,
                borderRadius: 2,
              }}
            >
              DESCARGAR TXT
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "justifyContent", mt: 3 }}>
        <Button
          onClick={mostrarCambioDePrecio}
          sx={{ mx: "auto" }}
          variant="contained"
          color={!mostrarInput ? "primary" : "error"}
        >
          {textoBotonCambiarPrecioInput}
        </Button>
      </Box>
      {mostrarInput && (
        <CambiarPrecioVianda
          open={mostrarInput}
          onClose={() => setMostrarInput(false)}
        />
      )}
    </>
  ) : (
    <>
      <Navbar />
      <NotAllow />
    </>
  );
}

export default Reporte;
